import { Input } from '@connected/ui/components/input';

import type { FormTableFieldApi } from '../types';

export type TextFieldProps = {
    /** Field API from FormTable cell renderer */
    field: FormTableFieldApi<string | null | undefined>;
    /** Input placeholder text */
    placeholder?: string;
    /** Whether the field is disabled */
    disabled?: boolean;
    /** Additional class name */
    className?: string;
    /** Called when field value changes (for custom side effects like API patching) */
    onValueChange?: (value: string | null) => void;
};

/**
 * TextField - A text input wrapper for use in FormTable cells.
 *
 * Integrates with FormTable's field API to provide form-connected text input.
 */
export function TextField({
    field,
    placeholder,
    disabled = false,
    className = 'w-full',
    onValueChange,
}: TextFieldProps) {
    return (
        <Input
            name={field.name}
            value={String(field.state.value ?? '')}
            onChange={(e) => {
                const value = e.target.value || null;
                field.handleChange(value as any);
            }}
            onBlur={() => {
                field.handleBlur();
                // Trigger side effect (e.g., API patch) on blur
                if (onValueChange) {
                    onValueChange(field.state.value as string | null);
                }
            }}
            placeholder={placeholder}
            disabled={disabled}
            className={className}
        />
    );
}
